import React, { useContext, useEffect, useState } from 'react'
import Api from '../api/api'
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  useDisclosure,
  Button,
  VStack,
  Checkbox,
} from '@chakra-ui/react'

function ActionPopup({ action, setAction, includeButton = false, fixed = false }: any) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [checkedItems, setCheckedItems] = useState([])
  const [checkListItems, setCheckListItems] = useState([])
  const [loading, setLoading] = useState(true)
  const cancelRef = React.useRef()

  useEffect(() => {
    if (action) {
      setCheckListItems(
        action.actions_list.map((action) => {
          return action.text
        }),
      )
      setCheckedItems(new Array(checkListItems.length).fill(false))
      setLoading(false)
      if (!includeButton) {
        onOpen()
      }
    }
  }, [action, checkListItems.length, onOpen, includeButton])

  const allChecked = checkedItems.every(Boolean)

  const handleCheckboxChange = (index) => {
    const newCheckedItems = [...checkedItems]
    newCheckedItems[index] = !newCheckedItems[index]
    setCheckedItems(newCheckedItems)
  }

  const handleSubmit = () => {
    setLoading(true)
    const itemsForUpdate = checkListItems.filter((item, index) => checkedItems[index])

    return Api.saveAction(action.id, itemsForUpdate).then((response) => {
      if (response.ok) {
        setAction(null)
        onClose()
      } else {
        setLoading(false)
      }
    })
  }

  const buttonFixedStyle = fixed ? { position: 'fixed' as const, bottom: 4, right: 4 } : {}
  return (
    <>
      {includeButton && (
        <Button lineHeight={1} onClick={onOpen} colorScheme='green' {...buttonFixedStyle}>
          Work end
        </Button>
      )}
      <AlertDialog
        motionPreset='slideInBottom'
        leastDestructiveRef={cancelRef}
        isOpen={isOpen}
        onClose={includeButton ? onClose : undefined}
        isCentered
      >
        <AlertDialogOverlay />
        <AlertDialogContent>
          <AlertDialogHeader>{includeButton ? 'Darbo pabaiga' : 'Darbo pradžia'}</AlertDialogHeader>
          {includeButton && <AlertDialogCloseButton />}
          <AlertDialogBody>
            <VStack align='start' spacing={2}>
              {checkListItems.map((item, index) => (
                <Checkbox
                  key={index}
                  isChecked={checkedItems[index]}
                  onChange={() => handleCheckboxChange(index)}
                >
                  {item}
                </Checkbox>
              ))}
            </VStack>
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button
              mt={4}
              colorScheme='green'
              isDisabled={!allChecked}
              onClick={handleSubmit}
              isLoading={loading}
            >
              Submit
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  )
}

export default ActionPopup
